export default (el) => el.blur();
